import { defineStore } from 'pinia';
import API from '@/shared/helpers/API.js';
import {useOrdersStore} from "@/console-new/stores/orders.store";
import {useUserStore} from "@/console-new/stores/user.store";
import {useUnchangingStore} from "@/console-new/stores/unchanging.store";
import {useRoomsOrdersStore} from "@/console-new/stores/roomsorders.store";
import {useNativeStore} from "@/console-new/stores/native.store";

export const useAblyStore = defineStore('ably', {
	state: () => ({
		ably: null,
		isSuspended: false,
		activeChannels: [],
	}),
	getters: {
	},
	actions: {
		startAbly(callback = null) {

			if(this.ably === null) {

				this.ably = new Ably.Realtime({
					authCallback: (tokenParams, callback) => {

						API.init().getAblyAuthToken((response) => {
							if(response && response.result === "OK") {
								callback(null, response.token_request);
							} else {
								callback(new Error('Failed to get Ably auth token:' + response.details ? response.details : 'Unknown error'));
							}
						});
					}
				});
				this.ably.connection.once('connected', () => {
					callback && callback();
				});
				this.ably.connection.on('connected', () => {
					const unchangingStore = useUnchangingStore();
					unchangingStore.offline = false;
					this.isSuspended = false;
					console.log("Connection to ably established");
				});
				this.ably.connection.on('disconnected', () => {
					const unchangingStore = useUnchangingStore();
					unchangingStore.offline = true;
					console.log("Connection to ably disconnected");
				});
				this.ably.connection.on('suspended', () => {
					//TODO flag to check fiscal orders when connection is restored
					console.log("Connection to ably suspended");
					this.isSuspended = true;
				});
			} else {
				callback && callback();
			}

		},
		subscribeToChannel(channelKey, listener, callback = null) {
			if(this.activeChannels.includes(channelKey)) {
				return;
			}
			this.activeChannels.push(channelKey);

			const channel = this.ably.channels.get(channelKey);
			channel.subscribe(listener).then(() => {
				console.log('Subscribed to channel: ' + channelKey);
				callback && callback();
			});

		},
		unsubscribeFromChannel(channelKey) {
			const channel = this.ably.channels.get(channelKey);
			if(channel) {
				channel.unsubscribe();
				try {
					channel.detach();
					console.log("Unsubscribed from channel: " + channelKey);
				} catch (e) {
					console.error("Error unsubscribing from channel: " + channelKey, e);
				}
				this.activeChannels = this.activeChannels.filter(c => c !== channelKey);
			}
		},

		subscribeToOpsUpdates(callback = null) {
			const userStore = useUserStore();
			if(userStore.currBusinessId === null) {
				console.log('No business selected, cannot subscribe to updates');
				return;
			}
			const channelKey = ENVIRONMENT+':business-ops:'+userStore.currBusinessId;
			this.subscribeToChannel(channelKey, this.opsUpdatesListener, callback);
		},
		unsubscribeFromOpsUpdates() {
			const userStore = useUserStore();
			if(userStore.currBusinessId === null) {
				console.log('No business selected, cannot unsubscribe from updates');
				return;
			}
			const channelKey = ENVIRONMENT+':business-ops:'+userStore.currBusinessId;
			this.unsubscribeFromChannel(channelKey);
		},
		opsUpdatesListener(message) {
			//console.log('Received a ABLY operation message ('+message.name+'): '+JSON.stringify(message.data));

			let excludedStations = useNativeStore().excludedStations.map(s => s !== "null" ? parseInt(s) : s);

			if(message.name === 'new-order') {

				const ordersStore = useOrdersStore();
				ordersStore.getNewOrderData(message.data.order_id, (order) => {
					if(order) {
						if(!excludedStations.includes(order.payment_user_id ? Number(order.payment_user_id) : "null")) {
							if(order.paid || order.type === "multi") {
								ordersStore.getFiscalUpdates();
							}
						}
					}
				});

			} else if(message.name === 'order-update') {

				const ordersStore = useOrdersStore();
				ordersStore.applyOrdersUpdates(message.data.orders, true, message.data.payments);

				message.data.orders.forEach((order) => {
					if(order.hasOwnProperty("payment_user_id") && excludedStations.includes(order.payment_user_id ? Number(order.payment_user_id) : "null")) {
						return;
					}

					if(order.hasOwnProperty("new_order_payment") && order.new_order_payment) {
						ordersStore.getFiscalUpdates();
					} else if(order.hasOwnProperty("paid") && order.paid) {
						ordersStore.getFiscalUpdates();
					}
				});

			} else if(message.name === 'call-update') {

				const roomsOrdersStore = useRoomsOrdersStore();
				//TODO this is currently replacing the existing calls, effectively handling only the latest call
				// we should request the full list of calls on init (similar to fiscal prints)
				roomsOrdersStore.initRoomsTablesCalls([message.data]);

			}
		},
	}
});







